import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/solution/neirong.png'
import _imports_1 from '@/assets/images/solution/jishu.png'
import _imports_2 from '@/assets/images/solution/fuwu.png'


const _hoisted_1 = { class: "education" }
const _hoisted_2 = { class: "fays" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "yycj" }
const _hoisted_5 = { class: "yycj-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "yyal" }
const _hoisted_8 = { class: "yyal-content" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "detail" }

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'EducationModel',
  setup(__props) {

const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesList: any = ref({})

const toOtherPath = (url: string, pageTitle: any) => {
  router.push(url);
  store.state.pageTitle = [...pageTitle]
}
onMounted(async () => {
  selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
    casesList.value = [...res].filter(e => e.industry == 3).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0))[0] || {}
  })

  const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
  const educationMp4: any = await asynchronousRetrieval('webimg/gif/education.gif');
  loadUrl.value = { fays_bg, educationMp4 }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"title-font-style-m\" style=\"color:#000000;\" data-v-86a1e374>教育解决方案</div><div class=\"illustrate\" data-v-86a1e374><div data-v-86a1e374>针对教育行业课程创建教学场景和虚拟仿真课件，实现教学内容的场景化和教学质量的闭环管理，突出互动性和趣味性，达到高效、有趣、安全的教学效果。</div></div><div class=\"subtitle\" data-v-86a1e374>行业痛点</div><div data-v-86a1e374><div class=\"disadvantage\" data-v-86a1e374>数实结合的沉浸式教学体验可以实现对传统教学方式的变革，为教育行业带来全新的体验和机会。</div></div><div class=\"subtitle\" data-v-86a1e374>方案优势</div>", 5)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.fays_bg
      }, null, 8, _hoisted_3),
      _cache[1] || (_cache[1] = _createStaticVNode("<div data-v-86a1e374><div data-v-86a1e374><img src=\"" + _imports_0 + "\" data-v-86a1e374><div class=\"title\" data-v-86a1e374>内容优势</div><div data-v-86a1e374>XR可视化培训相比传统方式，更为直观易学，有效缩短员工培训时间，提高培训效率。</div></div><div data-v-86a1e374><img src=\"" + _imports_1 + "\" data-v-86a1e374><div class=\"title\" data-v-86a1e374>技术优势</div><div data-v-86a1e374>以互动性+趣味性打造XR虚拟仿真教学平台，实现课程“教-学-练-考”的闭环课程体系。</div></div><div data-v-86a1e374><img src=\"" + _imports_2 + "\" data-v-86a1e374><div class=\"title\" data-v-86a1e374>服务优势</div><div data-v-86a1e374>提供内容+设备+软件定制化安装服务，7x24全天候技术服务支持。</div></div></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "subtitle" }, "应用场景", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: loadUrl.value.educationMp4
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "subtitle" }, "应用案例", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toOtherPath(`/case_detail?id=${casesList.value.id}&pathName=解决方案,教育解决方案,应用案例`, ['解决方案', '教育解决方案', '应用案例'])))
        }, [
          _createElementVNode("img", {
            src: casesList.value.ossPath
          }, null, 8, _hoisted_9),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(casesList.value.title), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(casesList.value.introduction), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})